import { render, staticRenderFns } from "./GamePreviewCardXs.vue?vue&type=template&id=6994f51a&scoped=true"
import script from "./GamePreviewCardXs.vue?vue&type=script&lang=js"
export * from "./GamePreviewCardXs.vue?vue&type=script&lang=js"
import style0 from "./GamePreviewCardXs.vue?vue&type=style&index=0&id=6994f51a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6994f51a",
  null
  
)

export default component.exports